<template>
  <tbody class="bg-white divide-y divide-gray-200">
    <tr v-for="item in wallets" :key="item.id">
      <td class="px-6 py-4 whitespace-nowrap">
        <div class="flex items-center">
          <div class="flex-shrink-0 h-10 w-10">
            <img
              class="h-10 w-10 rounded-full"
              src="https://cdn.thewirecutter.com/wp-content/uploads/2020/02/slimwallets-lowres-1208.jpg"
              alt=""
            />
          </div>
          <div class="ml-4">
            <div class="text-sm font-medium text-gray-900">{{ item.name }}</div>
            <!-- <div class="text-sm text-gray-500">jane.cooper@example.com</div> -->
          </div>
        </div>
      </td>
      <td class="px-6 py-4 whitespace-nowrap">
        <div class="text-sm text-gray-900">{{ convertToRupiah(item.saldo) }}</div>
        <!-- <div class="text-sm text-gray-500">Optimization</div> -->
      </td>

      <td class="px-6 py-4 whitespace-nowrap">
        <span
          class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
        >
          Active
        </span>
      </td>
      <!-- <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">Admin</td> -->
      <!-- <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <a
          href="#"
          class="text-pink-600 hover:text-indigo-900"
          @click.prevent="showFormTransactions(item.id)"
          >Add Transactions</a
        >
      </td> -->
      <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
        <a
          href="#"
          class="text-indigo-600 hover:text-indigo-900"
          @click.prevent="financeDetail(item.id)"
          >Dive into</a
        >
      </td>
    </tr>

    <!-- More people... -->
  </tbody>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ListWallet",
  methods: {
    financeDetail(id) {
      this.$store.dispatch("financeDetails", id);
    },
    convertToRupiah(angka) {
      var rupiah = "";
      var angkarev = angka.toString().split("").reverse().join("");
      for (var i = 0; i < angkarev.length; i++)
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + ".";
      return (
        "Rp. " +
        rupiah
          .split("", rupiah.length - 1)
          .reverse()
          .join("")
      );
    },
  },
  computed: {
    ...mapState(["wallets"]),
  },
};
</script>

<style>
</style>